import type { DealFixedRateLoanData, DealFloatingRateLoanData, DealForwardData } from '@src/types/OTC';
import { getOtcDealSpreadDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import { InlineFormattedNumber } from '@talos/kyoko';

type DealWithSpread = DealForwardData | DealFixedRateLoanData | DealFloatingRateLoanData;

export const SpreadDisplay = ({ instrumentData }: { instrumentData: DealWithSpread }) => {
  const displayValue = getOtcDealSpreadDisplayValue(instrumentData);
  if (!displayValue) {
    return null;
  }
  return (
    <InlineFormattedNumber
      data-testid="instrument-inspector-section-field-value"
      number={displayValue.value}
      currency={displayValue.currency}
      background="backgroundBlotterTableRowHover"
    />
  );
};
